import $ from 'jquery';

const GallerySlider = (el, defaultIndex = 0) => {
    const $el = $(el);
    const $slider = $el.find('[data-slider]');
    const $slides = Array.from($slider.find('[data-image-index]'));
    const $prevBtn = $el.find('[data-slider-nav="prev"]');
    const $nextBtn = $el.find('[data-slider-nav="next"]');
    const $progressText = $el.find('[data-slider-progress-text]');
    const $progressFill = $el.find('[data-slider-progress-fill]');

    let initialIndex = $slider.data('current-index');
    let currentIndex = defaultIndex;
    let isProgrammaticScroll = false;

    const scrollToSlide = (index) => {
        if (index >= 0 && index < $slides.length) {
            isProgrammaticScroll = true;
            $slider[0].scrollTo({
                left: $slides[index].offsetLeft,
                behavior: 'smooth',
            });
            currentIndex = index;
            $slider.data('current-index', index);
            updateButtons();
            updateProgress();

            setTimeout(() => {
                isProgrammaticScroll = false;
            }, 1000);
        }
    };

    const updateProgress = () => {
        if($progressText.length && $progressFill.length) {
            $progressText.text(`${currentIndex + 1} / ${$slides.length}`);
            const percentage = ((currentIndex + 1) / $slides.length) * 100;
            $progressFill.css('width', `${percentage}%`);
        }
    };

    const updateButtons = () => {
        $prevBtn.prop('disabled', currentIndex === 0);
        $nextBtn.prop('disabled', currentIndex === $slides.length - 1);
    };

    const handleScrollUpdate = () => {
        if (isProgrammaticScroll) return;

        const scrollLeft = $slider.scrollLeft();
        const maxScrollLeft = $slider[0].scrollWidth - $slider[0].clientWidth;
        const slideOffsets = $slides.map($slide => $slide.offsetLeft);

        let closestIndex;
        // If we're at (or very close to) the end, force last slide
        if (Math.abs(scrollLeft - maxScrollLeft) < 2) {
            closestIndex = $slides.length - 1;
        } else {
            closestIndex = slideOffsets.reduce((closest, left, i) => {
                return Math.abs(left - scrollLeft) < Math.abs(slideOffsets[closest] - scrollLeft)
                    ? i
                    : closest;
            }, 0);
        }

        if (closestIndex !== currentIndex) {
            currentIndex = closestIndex;
            updateButtons();
            updateProgress();
        }
    };

    $prevBtn.on('click', () => scrollToSlide(currentIndex - 1));
    $nextBtn.on('click', () => scrollToSlide(currentIndex + 1));

    $slider.on('scroll', handleScrollUpdate);

    if(defaultIndex !== initialIndex) {
        scrollToSlide(defaultIndex);
    }

    updateButtons();
};

export default GallerySlider;
